// KHO ẢNH (05/10/2026) — phần THUẦN dùng chung Boss / plugin / trang web.
//
// Kho ảnh của MỘT chủ (Boss) = ảnh TẢI LÊN ở trang "Kho ảnh" (bảng kho_anh, mã "ka-…", có chú thích, album, nhãn)
//                            + ảnh của sản phẩm trong thư viện Sản phẩm (bảng san_pham_anh, mã "spa-…", album hiện là "Sản phẩm: <tên>").
// Bước bình luận / trả lời kèm ảnh có tham số anh_chon = TẬP ẢNH người dùng chọn, dạng chữ một dòng, các mục cách nhau dấu phẩy:
//   ka-…/spa-…        một ảnh cụ thể
//   album:<tên>       mọi ảnh tải lên thuộc album đó
//   nhan:<tên>        mọi ảnh tải lên có nhãn đó
//   sp:<mã sản phẩm>  mọi ảnh của sản phẩm đó
//   <tên>             (không tiền tố) mọi ảnh tải lên có album HOẶC nhãn đúng tên đó — chữ tự do của ô tham số vẫn có nghĩa (trang luôn ghi rõ tiền tố)
// Lúc chạy bot hỏi Boss tập ảnh (chỉ ảnh của CHỦ bot — server/src/kho-anh.ts) rồi chọn NGẪU NHIÊN một ảnh (tránh lặp N lượt gần cho cùng nick).
// anh_chon rỗng = như trước (ảnh sản phẩm của kịch bản; AI chọn theo chú thích / xoay vòng).

export const ID_ANH_KHO = /^(?:ka-[a-z0-9]{6,24}|spa-[a-z0-9]{6,24})$/;
export const ID_ANH_TAI_LEN = /^ka-[a-z0-9]{6,24}$/;
const ID_SP = /^sp-[a-z0-9]{6,24}$/;
/** Số mục tối đa trong anh_chon (ô tham số sơ đồ ≤ 500 ký tự: 20 mã ≈ 380 ký tự). Nhiều hơn → dùng album / nhãn. */
export const ANH_CHON_TOI_DA = 20;
export const TEN_NHOM_TOI_DA = 40; // ký tự của tên album / nhãn
export const NHAN_MOI_ANH_TOI_DA = 10;
export const CHU_THICH_TOI_DA = 120; // = MO_TA_ANH_TOI_DA của ảnh sản phẩm
/** Ảnh tải lên: ĐÃ thu nhỏ trên trình duyệt (≤ 1024 px, JPEG) — cùng ngưỡng ảnh sản phẩm. */
export const KA_BYTE_TOI_DA = 290_000;
export const KA_CANH_TOI_DA = 1024;
export const KA_MOI_CHU_TOI_DA = 20_000;
/** Ảnh gốc (trước khi trình duyệt thu nhỏ) tối đa — lớn hơn thì báo, không đọc vào bộ nhớ. */
export const KA_TEP_GOC_TOI_DA = 25 * 1024 * 1024;

export interface AnhChon { anh: string[]; album: string[]; nhan: string[]; sp: string[]; ten?: string[] }

// Ký tự điều khiển + những ký tự phá định dạng (dấu phẩy tách mục, nháy kép phá YAML, ngoặc nhọn của mẫu {{…}}).
const BO_KY_TU = /[\u0000-\u001f\u007f,"{}]/g;

/** Tên album / nhãn: một dòng, bỏ dấu phẩy, nháy kép, ngoặc nhọn, ký tự điều khiển; gộp khoảng trắng; ≤ TEN_NHOM_TOI_DA ký tự. Không phải chữ → "". */
export function chuanTenNhom(v: unknown): string {
  if (typeof v !== "string") return "";
  const s = v.replace(/[\r\n\t]+/g, " ").replace(BO_KY_TU, "").replace(/\s+/g, " ").trim();
  return Array.from(s).slice(0, TEN_NHOM_TOI_DA).join("").trim();
}

/** Danh sách nhãn: mảng hoặc chữ cách nhau dấu phẩy; bỏ rỗng, bỏ trùng (phân biệt hoa thường), ≤ NHAN_MOI_ANH_TOI_DA. */
export function chuanDsNhan(v: unknown): string[] {
  const ds = Array.isArray(v) ? v : typeof v === "string" ? v.split(",") : [];
  const ra: string[] = [];
  for (const x of ds) {
    const t = chuanTenNhom(x);
    if (t && !ra.includes(t)) ra.push(t);
    if (ra.length >= NHAN_MOI_ANH_TOI_DA) break;
  }
  return ra;
}

/** Chú thích ảnh: một dòng, ≤ CHU_THICH_TOI_DA ký tự (tiếng Việt, emoji, ' " < & \ giữ nguyên — trang dựng bằng textContent). */
export function chuanChuThich(v: unknown): string {
  if (typeof v !== "string") return "";
  const s = v.replace(/[\u0000-\u001f\u007f]+/g, " ").replace(/\s+/g, " ").trim();
  return Array.from(s).slice(0, CHU_THICH_TOI_DA).join("").trim();
}

/** Đọc anh_chon. loi = các mục không hiểu (câu tiếng Việt). Bỏ trùng, giữ thứ tự. */
export function docAnhChon(s: unknown): Required<AnhChon> & { loi: string[] } {
  const r: Required<AnhChon> & { loi: string[] } = { anh: [], album: [], nhan: [], sp: [], ten: [], loi: [] };
  if (typeof s !== "string" || !s.trim()) return r;
  const them = (ds: string[], v: string) => { if (!ds.includes(v)) ds.push(v); };
  let soMuc = 0;
  for (const raw of s.split(",")) {
    const m = raw.trim();
    if (!m) continue;
    soMuc++;
    const nhom = /^(album|nhan):(.*)$/.exec(m);
    if (ID_ANH_KHO.test(m)) them(r.anh, m);
    else if (nhom) {
      const ten = nhom[2]!.trim().replace(/\s+/g, " ");
      if (!ten) r.loi.push(`thiếu tên ${nhom[1] === "album" ? "album" : "nhãn"} sau “${nhom[1]}:”`);
      else them(nhom[1] === "album" ? r.album : r.nhan, ten);
    } else if (/^sp:/.test(m)) {
      if (ID_SP.test(m.slice(3))) them(r.sp, m.slice(3));
      else r.loi.push(`không hiểu “${Array.from(m).slice(0, 40).join("")}” (sau “sp:” phải là mã sản phẩm)`);
    } else if (/^(?:ka|spa)-/.test(m)) r.loi.push(`không hiểu “${Array.from(m).slice(0, 40).join("")}” (mã ảnh sai dạng)`);
    else them(r.ten, m.replace(/\s+/g, " "));
  }
  if (soMuc > ANH_CHON_TOI_DA) r.loi.push(`chọn tối đa ${ANH_CHON_TOI_DA} mục (đang ${soMuc}) — nhiều ảnh hơn thì gom vào một album rồi chọn album`);
  return r;
}

export function ghiAnhChon(c: AnhChon): string {
  return [...c.anh, ...c.album.map((x) => `album:${x}`), ...c.nhan.map((x) => `nhan:${x}`), ...c.sp.map((x) => `sp:${x}`), ...(c.ten ?? [])].join(",");
}

export const anhChonRong = (c: AnhChon): boolean => !c.anh.length && !c.album.length && !c.nhan.length && !c.sp.length && !c.ten?.length;

/** Lỗi của anh_chon (null = hợp lệ / rỗng). Câu dùng sau tên ô: “Ảnh dùng” <lỗi>. */
export function loiAnhChon(s: unknown): string | null {
  if (s === undefined || s === null || s === "") return null;
  if (typeof s !== "string") return "phải là chữ";
  const r = docAnhChon(s);
  return r.loi.length ? r.loi.slice(0, 3).join("; ") : null;
}

export const ANH_CHON_RONG_MO_TA = "Chưa chọn — bot lấy ảnh sản phẩm của kịch bản (AI chọn theo chú thích / xoay vòng)";

/** Tóm tắt cho người: "3 ảnh · album “Tết” · nhãn “áo” · ảnh sản phẩm “SketchUp”". tenSp: mã sản phẩm → tên (thiếu → mã). */
export function tomTatAnhChon(s: unknown, tenSp: Record<string, string> = {}): string {
  const c = docAnhChon(s);
  if (anhChonRong(c)) return ANH_CHON_RONG_MO_TA;
  const p: string[] = [];
  if (c.anh.length) p.push(`${c.anh.length} ảnh`);
  for (const a of c.album) p.push(`album “${a}”`);
  for (const n of c.nhan) p.push(`nhãn “${n}”`);
  for (const sp of c.sp) p.push(`ảnh sản phẩm “${tenSp[sp] ?? sp}”`);
  for (const t of c.ten) p.push(`album/nhãn “${t}”`);
  return p.join(" · ");
}

/** Chọn NGẪU NHIÊN một ảnh (rnd ∈ [0,1); giá trị lỗi → kẹp vào mảng). Rỗng → null. */
export function chonNgauNhienAnh<T>(ungVien: readonly T[], rnd: () => number): T | null {
  if (!ungVien.length) return null;
  const x = rnd();
  const i = Number.isFinite(x) ? Math.floor(x * ungVien.length) : 0;
  return ungVien[Math.max(0, Math.min(ungVien.length - 1, i))]!;
}
